import {
  ADMIN_DELETE_SPECIMEN_REQUEST,
  ADMIN_UPDATE_SPECIMEN_REQUEST,
} from "../adminConstants";

export const updateSpecimen = (payload = {}) => {
  return {
    type: ADMIN_UPDATE_SPECIMEN_REQUEST,
    payload,
  };
};

export const deleteSpecimen = (payload: {
  case_id: number;
  specimen_id: number;
}) => {
  return {
    type: ADMIN_DELETE_SPECIMEN_REQUEST,
    payload,
  };
};
